<div class="sec-title">
  <h1>Modifier le client</h1>
</div>

<div><a class="btn btn-action" href="/clients" routerLink="/clients" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux clients</a></div>

<div class="float-lg-end col-lg-3 col-md-12" *ngIf="!isForeman" >
  <a  role="button" routerLink="/ajouter-soumission/{{clientInfo.client_id}}/ajouter" ><button type="button" class="btn btn-success btn-action"><i class="bi bi-plus-circle" data-toggle="tooltip" data-placement="top" title="Ajouter une soumission"></i> Ajouter un soumission</button></a>
</div>


<div style="width:100%;">
  <div class="alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}</div>
<form [formGroup]="editClientForm" (ngSubmit)="onSubmit(editClientForm.value, clientTypeForm.value)" novalidate>
  <fieldset class="col-sm-12 col-lg-12 float-lg-left form-group mb-3">
    <legend>Information personelle</legend>
    <div class="fieldset-wrap">
      <div class="float-lg-start col-sm-12 col-lg-5 ">

        <div class="form-group mb-3">
          <label for="first_name" class="form-label">Prénom</label>
          <input type="text" class="form-control" name="first_name" id="first_name" formControlName="first_name" />
        </div>

        <div class="form-group mb-3">
          <label for="last_name" class="form-label">Nom</label>
          <input type="text" class="form-control" name="last_name" id="last_name" formControlName="last_name" />
        </div>

        <div class="form-group mb-3">
          <label for="gender" class="form-label">Genre</label>
          <select class="form-select" name="gender" id="gender" formControlName="gender">
            <option value="N/A" selected>N/A</option>
            <option value="M">Homme</option>
            <option value="F">Femme</option>
          </select>
        </div>
        <div class="form-group mb-3" [formGroup]="clientTypeForm" *ngFor="let contactType of contactTypeList; let i = index;">
          <div *ngIf="contactType.client_contact_type_id==4;then email_wrap" ></div>
          <ng-template #email_wrap>
            <div class="mb-3 col-12" *ngFor="let clientEmail of clientEmails; let i = index;">
                <label for="contact_type_email{{i}}-{{contactType.client_contact_type_id}}" class="col-10 form-label">{{contactType.name}} {{i+1}}</label>
                <div class="float-end col-2">
                  <div class="form-group mb-3 ms-3 col-12" *ngIf="i>0">
                    <span>
                      <a href="javascript:void(0);" (click)="removeEmailClient(i)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
                    </span>
                  </div>
                </div>
                <div class="float-start col-10 form-group mb-3 ">
                <input type="text" class="form-control" name="contact_type_email{{i}}-{{contactType.client_contact_type_id}}" formControlName="contact_type_email{{i}}-{{contactType.client_contact_type_id}}" (change)="onChangeEmail(i, $event.target)" />
                <input type="hidden" class="form-control" id="id_email{{i}}_{{contactType.client_contact_type_id}}" value="{{contactType.client_contact_type_id}}" />
                </div>
                
            </div>
          </ng-template>
        </div>
        <div class="float-start col-12">
          <div class="form-group mb-3 ms-3">
             <a href="javascript:void(0);" (click)="addEmailClient()" role="button">
                <i class="bi bi-plus-circle-fill btn-add-one"></i>
                <span class="txt-add-one ms-2">Ajouter un courriel</span>
            </a>
          </div>
        </div>
      </div>
      <div class="float-lg-end col-sm-12 col-lg-6">
        <div class="form-group mb-3" [formGroup]="clientTypeForm" >
          <div  class="form-group mb-3" *ngFor="let contactType of contactTypeList; let i = index;" >
            <div *ngIf="contactType.client_contact_type_id!=4;then contact_wrap" ></div>
            <ng-template #contact_wrap>
              <label for="contact_type_{{contactType.client_contact_type_id}}" class="form-label">{{contactType.name}}</label>
              <input type="text" class="form-control" name="contact_type_{{contactType.client_contact_type_id}}" formControlName="contact_type_{{contactType.client_contact_type_id}}" />
              <input type="hidden" class="form-control" id="id_{{contactType.client_contact_type_id}}" value="{{contactType.client_contact_type_id}}" />
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </fieldset>

  <fieldset class="col-sm-12 col-lg-12 float-lg-left form-group mb-3">
    <legend>Adresse Propriétaire</legend>
    <div class="fieldset-wrap">
      <div class="float-lg-start col-sm-12 col-lg-5 ">
        <div class="form-group mb-3">
          <label for="address" class="form-label">Adresse</label>
          <input type="text" class="form-control" name="address" id="address" formControlName="address" />
        </div>

        <div class="form-group mb-3">
          <label for="city" class="form-label">Ville</label>
          <input type="text" class="form-control" name="city" id="city" formControlName="city" />
        </div>

        <div class="form-group mb-3">
          <label for="postalcode" class="form-label">Code postal</label>
          <input type="text" class="form-control" name="postalcode" id="postalcode" formControlName="postalcode" />
        </div>

      </div>
      <div class="float-lg-end col-sm-12 col-lg-6 ">

        <div class="form-group mb-3">
          <label for="address2" class="form-label">App/Suite</label>
          <input type="text" class="form-control" name="address2" id="address2" formControlName="address2" />
        </div>

        <div class="form-group mb-3">
          <label for="province" class="form-label">Province</label>
          <input type="text" class="form-control" name="province" id="province" formControlName="province" />
        </div>

        <div class="form-group mb-3">
          <label for="country" class="form-label">Pays</label>
          <input type="text" class="form-control" name="country" id="country" formControlName="country" />
        </div>
      </div>

    </div>
  </fieldset>

  <fieldset class="col-sm-12 col-lg-12 float-lg-left form-group mb-3">
    <legend>Autres informations</legend>
    <div class="fieldset-wrap">
      <div class="form-group float-lg-start mb-3 col-sm-12 col-lg-5">
        <label for="referral" class="form-label">Provenance de la publicité</label>
        <select class="form-select" name="referral" id="referral" formControlName="referral">
          <option *ngFor="let referral of referralList" [value]="referral.client_referral_id">
            {{referral.name}}
          </option>
        </select>
      </div>
      <div class="form-group float-lg-end mb-3 col-sm-12 col-lg-6">
        <label for="referral_note" class="form-label">Référence</label>
        <textarea class="form-control" name="referral_note" id="referral_note" formControlName="referral_note"></textarea>
      </div>

      <div class="form-group mb-3 col-5">
        <label for="language" class="form-label">Langue</label>
        <select class="form-select" name="language" id="language" formControlName="language">
          <option *ngFor="let language of languageList" [value]="language.client_language_id">
              {{language.name}}
          </option>
        </select>
      </div>
    </div>
  </fieldset>
  <p>Crée par {{clientInfo.account_fname}} {{clientInfo.account_lname}} - {{clientInfo.client_created  | date:'medium'}}
  <br/>Dernière mise à jour: {{clientInfo.client_updated  | date:'medium'}}</p>
  <button type="submit" class="btn btn-primary">Enregistrer</button>

</form>
</div>
<hr/>